import { generatePath } from 'react-router-dom'
import { CONTENT_PLAN_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Workspace } from 'types'
import { Layers5 } from 'blaze-ui/icons/24'
import { DesktopBadge } from '../DesktopBadge/DesktopBadge'

interface Props {
  workspace: Workspace
  onPress: () => void
}

const NavMenuContentPlanItem = ({ workspace, onPress }: Props) => {
  const to = generatePath(CONTENT_PLAN_PATH, { workspaceId: workspace.id })

  return (
    <NavMenuItem icon={Layers5} activeIcon={Layers5} to={to} onPress={onPress} label="Content Plan">
      <DesktopBadge />
    </NavMenuItem>
  )
}

export { NavMenuContentPlanItem }
